<!DOCTYPE html>
<div class="sheet-wrapper">

  <!-- Heading -->
  <h2 [innerHTML]="goldRingsOnBoardData?.title"></h2>

  <!-- GIF container -->
  <div class="gif-container">
    <img [src]="goldRingsOnBoardData?.image" alt="gif-image"/>
  </div>

  <!-- Card details -->
  <div class="card-details">
    <!-- Paragraph -->
    <p>{{goldRingsOnBoardData?.description}}</p>
    <!-- Button -->
    <button (click)="pickGoldRings()">{{goldRingsOnBoardData?.button_label}}</button>
  </div>
</div>
